<template>
  <div class="binary-choice-buttons">
    <button
      type="button"
      @click="selectChoice(1)"
      :class="[
        'choice-button like-button',
        { 'selected': modelValue === 1 }
      ]"
    >
      <span class="button-emoji">👍</span>
      <span class="button-label">喜欢/符合</span>
    </button>
    
    <button
      type="button"
      @click="selectChoice(0)"
      :class="[
        'choice-button dislike-button',
        { 'selected': modelValue === 0 }
      ]"
    >
      <span class="button-emoji">👎</span>
      <span class="button-label">不喜欢/不符合</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BinaryChoiceButton',
  props: {
    modelValue: {
      type: Number,
      default: null,
      validator: (value) => value === null || value === 0 || value === 1
    }
  },
  emits: ['update:modelValue'],
  methods: {
    selectChoice(value) {
      this.$emit('update:modelValue', value)
    }
  },
  mounted() {
    // 添加键盘快捷键支持
    this.handleKeyPress = (event) => {
      if (event.key === 'y' || event.key === 'Y' || event.key === '1') {
        this.selectChoice(1)
      } else if (event.key === 'n' || event.key === 'N' || event.key === '0') {
        this.selectChoice(0)
      }
    }
    window.addEventListener('keypress', this.handleKeyPress)
  },
  beforeUnmount() {
    window.removeEventListener('keypress', this.handleKeyPress)
  }
}
</script>

<style scoped>
.binary-choice-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 2rem 0;
}

.choice-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 2.5rem;
  border: 3px solid transparent;
  border-radius: 1rem;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 140px;
}

.choice-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.choice-button:active {
  transform: translateY(0);
}

.button-emoji {
  font-size: 3rem;
  margin-bottom: 0.5rem;
  transition: transform 0.3s ease;
}

.button-label {
  font-size: 1.125rem;
  font-weight: 600;
  color: #374151;
}

/* 喜欢按钮 */
.like-button {
  border-color: #e5e7eb;
}

.like-button:hover {
  border-color: #10b981;
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
}

.like-button.selected {
  border-color: #10b981;
  background: linear-gradient(135deg, #10b981, #14b8a6);
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
}

.like-button.selected .button-label {
  color: white;
}

.like-button.selected .button-emoji {
  transform: scale(1.2);
}

/* 不喜欢按钮 */
.dislike-button {
  border-color: #e5e7eb;
}

.dislike-button:hover {
  border-color: #ef4444;
  background: linear-gradient(135deg, #fef2f2, #fee2e2);
}

.dislike-button.selected {
  border-color: #ef4444;
  background: linear-gradient(135deg, #ef4444, #f87171);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.3);
}

.dislike-button.selected .button-label {
  color: white;
}

.dislike-button.selected .button-emoji {
  transform: scale(1.2);
}

/* 响应式设计 */
@media (max-width: 640px) {
  .binary-choice-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .choice-button {
    width: 100%;
    padding: 1.25rem 2rem;
    min-width: auto;
  }
  
  .button-emoji {
    font-size: 2.5rem;
  }
  
  .button-label {
    font-size: 1rem;
  }
}
</style>

